
import ProviderHoursTable from "../../../../../components/modules/providers/provider-management/components/hours-of-operation/ProviderHoursTable";
import Navigation from "../../../../../components/navigations/provider-management/detail/location-info/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";

export default function Template() {
  const { id } = useParentLoaderData(2);

  return (
    <Navigation activeTab="hours-of-operation" providerId={id}>
      <ProviderHoursTable/>
    </Navigation>
  );
}
